/**
 * Entities Layer - Domain models (logical entities)
 * Contiene interfaces, enums, constantes de negocio
 * CERO lógica, solo datos puros
 */

export * from './income-order';
export * from './invoice';
export * from './multimedia-file';
export * from './registro-compra';
